import { Box, Card, Grid, Typography } from '@mui/material';
import React from 'react';

import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faCloudWord } from '@fortawesome/sharp-regular-svg-icons';
import { useTheme } from '@mui/system';

export type Activite = {
    indicateurPrincipal: boolean;
    descriptionDetaillee: string;
};

export type ActiviteWidgetCallbackArgs = (activite: Activite, index: number) => void;

export type ActiviteWidgetType = {
    activite: Activite;
    actions?: Array<{
        name: string;
        icon?: React.ReactNode | React.FunctionComponent;
        tooltip?: string;
        text?: string;
        onClick: ActiviteWidgetCallbackArgs;
    }>;
    index?: number;
};

// exemple de style sur DisplayFile

export const ActiviteWidget: React.FunctionComponent<ActiviteWidgetType> = function ({
    activite,
    actions,
    index = -1,
}: ActiviteWidgetType) {
    const theme = useTheme();
    return (
        <Card sx={{ padding: '10px', cursor: 'pointer', margin: '15px 0' }}>
            <Grid
                container
                sx={{
                    marginLeft: '0px',
                }}
            >
                <Grid
                    item
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        paddingLeft: '0px',
                    }}
                >
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap="10px"
                        sx={{
                            margin: '0 12px 0',
                        }}
                    >
                        <Box
                            data-testid="test-id-status-color-box"
                            sx={{
                                margin: '0px',
                                padding: '10px',
                                borderRadius: '10px',
                                fontSize: '25px',
                                maxHeight: '65px',
                                backgroundColor: theme.palette.icon?.info?.backgroundColor,
                            }}
                        >
                            <FaOptionIcon
                                data-testid="test-id-mimetype-icone"
                                icon={faCloudWord}
                                color={theme.palette.primary.main}
                                sx={{ fontSize: '15px' }}
                            />
                        </Box>
                        <Box sx={{ padding: '0px 10px', minWidth: '150px' }}>
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 'bold' }}
                            >
                                {activite.indicateurPrincipal
                                    ? "Activité principale de l'établissement"
                                    : "L'activité n'est pas l'activité principale de l'établissement"}
                            </Typography>
                            <Typography variant="h6">{activite.descriptionDetaillee}</Typography>
                        </Box>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap="10px"
                        sx={{
                            margin: '0 0 0 auto',
                        }}
                    >
                        {actions
                            ? actions.map((action, key) => (
                                  <Box
                                      title={action.tooltip}
                                      data-testid={`test-id-${key}-handleClick-button`}
                                      onClick={() => action.onClick(activite, index)}
                                      role="button"
                                      key={action.name}
                                  >
                                      {action.icon || action.text}{' '}
                                  </Box>
                              ))
                            : null}
                    </Box>
                </Grid>
            </Grid>
        </Card>
    );
};
